module.exports = __webpack_public_path__ + "img/checkbox.2455da05.svg";